<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      d="M12 1C7.576 1 4 4.362 4 8.52c0 3.686 6.369 12.327 8 14.48 1.631-2.153 8-10.794 8-14.48C20 4.391 16.424 1 12 1zm0 12.239c-2.76 0-4.988-2.094-4.988-4.69 0-2.595 2.227-4.718 4.988-4.718 2.76 0 4.988 2.094 4.988 4.69 0 2.594-2.227 4.718-4.988 4.718z"
      transform="translate(-253 -260) translate(253 260)"
    />
  </svg>
</template>
